import $ from 'jquery';
import { carouselInit } from './carousel';
import themeEditor from './themeEditor';

const HeroCarousel = () => {
  if ($('[data-hero-carousel]').length === 0) {
    return;
  }
  
  // Initialize all carousels on page load and add them to the index
  $('[data-hero-carousel]').each((i, carousel) => {
    const section_id = $(carousel).parent().parent().data('sectionId');
    carouselInit(section_id, $(carousel));
  });

  themeEditor();
};

export { HeroCarousel };